<template>
  <main class="page-article">
    <div v-if="loading" class="loading"></div>
    <div v-else class="container">
      <div class="nav-back">
        <a role="button" @click="$router.go(-1)"><i class="las la-arrow-left"></i></a>
      </div>
      <div class="row row-content">
        <div class="col col-1">
          <h1 class="font-size-l">{{item.label}}</h1>
          <div class="bg-white" v-html="item.body"></div>
          <div class="flex-share flex">
            <div class="label font-bold">Compartir</div>
            <a :href="facebookLink()" onclick="return !window.open(this.href, 'Facebook', 'width=640,height=580')"><i class="lab la-facebook"></i></a>
            <a :href="twitterLink()" onclick="return !window.open(this.href, 'Twitter', 'width=640,height=580')"><i class="lab la-twitter"></i></a>
          </div>
        </div>

        <div class="col col-2">
          <div class="tags">
            <h3 class="title">Prácticas de Liderazgo</h3>
            <div
              v-for="(item, index) in item.practice" :key="'p1_' + index"
              class="tag">
              {{item}}
            </div>
          </div>
          <div class="tags">
            <h3 class="title">Componentes</h3>
            <div
              v-for="(item, index) in item.components" :key="'c1_' + index"
              class="tag">
              {{item}}
            </div>
          </div>
          <Banner2 />
        </div>
      </div>
    </div>
    <Infographics />
  </main>
</template>

<script>
import PageBaseMixin from '@/mixins/PageBase';

import Banner2 from '@/components/Banner2';
import Infographics from '@/components/Infographics';
import Html from '@/components/content/Html';

export default {
  components: {Banner2, Infographics},
  mixins: [PageBaseMixin],

  title: 'Escuela en territorio | Escuela de liderazgo',

  data() {
    return {
      loading: false,
      id: null,
      item: {},
      locationHref: null,
    }
  },

  methods: {
    facebookLink(){
      return `https://www.facebook.com/sharer/sharer.php?&amp;u=${this.locationHref}%2F&amp;display=popup&amp;ref=plugin&amp;src=share_button`;
    },
    twitterLink(){
      return `https://twitter.com/share?url=${this.locationHref}%2F&amp;text=Me gustó mucho este artículo`;
    },
  },
  
  created(){

    this.$store.commit('modal/setComponent', Html);
    const id = this.$route.params.article.split('-').pop();
    this.locationHref = window.location.href;

    this.loading = true;
    this.$api.get('/v1/article/', {id})
      .then(({body}) => {
        this.item = body.rows[0];
        if(this.item.practice){
          this.item.practice = this.item.practice.split(',');
        }
        if(this.item.components){
          this.item.components = this.item.components.split(',');
        }
  
        document.title = this.item.label + ' | Escuela de liderazgo';
      })
      .finally(() => {
        this.loading = false;
      });
  }
}
</script>

<style lang="scss" scoped>
.flex-share
{
  justify-content: flex-end;
  align-items: center;
  margin-top: 20px;

  .label
  {
    margin-right: 10px;
  }

  A
  {
    color: $blue-1;
    font-size: 34px;
    margin: 0 5px;
  }
}
</style>